/* tslint:disable */
/* eslint-disable */
/**
 * Spring API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface AddFeedSummaryResponse
 */
export interface AddFeedSummaryResponse {
    /**
     * 
     * @type {Array<string>}
     * @memberof AddFeedSummaryResponse
     */
    feedSummaryIds: Array<string>;
}

/**
 * Check if a given object implements the AddFeedSummaryResponse interface.
 */
export function instanceOfAddFeedSummaryResponse(value: object): value is AddFeedSummaryResponse {
    if (!('feedSummaryIds' in value) || value['feedSummaryIds'] === undefined) return false;
    return true;
}

export function AddFeedSummaryResponseFromJSON(json: any): AddFeedSummaryResponse {
    return AddFeedSummaryResponseFromJSONTyped(json, false);
}

export function AddFeedSummaryResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): AddFeedSummaryResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'feedSummaryIds': json['feed_summary_ids'],
    };
}

export function AddFeedSummaryResponseToJSON(json: any): AddFeedSummaryResponse {
    return AddFeedSummaryResponseToJSONTyped(json, false);
}

export function AddFeedSummaryResponseToJSONTyped(value?: AddFeedSummaryResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'feed_summary_ids': value['feedSummaryIds'],
    };
}

